// @ts-nocheck
import * as Types from '@src/types/graphql-types';

import { gql } from '@apollo/client';
import { DynamicProductFragmentDoc } from '../fragments/DynamicProduct.generated';
import * as React from 'react';
import * as Apollo from '@apollo/client';
import * as ApolloReactComponents from '@apollo/client/react/components';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
const defaultOptions = {} as const;
export type SrpRecommendedProductsQueryVariables = Types.Exact<{
  input: Types.GetSrpRecommendedProductsInput;
}>;


export type SrpRecommendedProductsQuery = { __typename?: 'Query', getSrpRecommendedProducts?: { __typename?: 'AssociatedProducts', products: Array<{ __typename?: 'Product', id?: string | null, productKey: string, productNumber: string, productSku?: string | null, lastBoughtUnix?: string | null, name: string, description?: string | null, gaProductCode?: string | null, isMarketplace: boolean, erp_type?: Array<string> | null, tags?: string | null, discount?: string | null, brand: { __typename?: 'Brand', key: string, erpKey: string, name?: string | null, color?: string | null }, images: Array<{ __typename?: 'CatalogImage', altText?: string | null, mediumUrl: string }> }> } | null };


export const SrpRecommendedProductsDocument = gql`
    query SrpRecommendedProducts($input: GetSrpRecommendedProductsInput!) {
  getSrpRecommendedProducts(input: $input) {
    products {
      ...DynamicProduct
    }
  }
}
    ${DynamicProductFragmentDoc}`;
export type SrpRecommendedProductsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<SrpRecommendedProductsQuery, SrpRecommendedProductsQueryVariables>, 'query'> & ({ variables: SrpRecommendedProductsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const SrpRecommendedProductsComponent = (props: SrpRecommendedProductsComponentProps) => (
      <ApolloReactComponents.Query<SrpRecommendedProductsQuery, SrpRecommendedProductsQueryVariables> query={SrpRecommendedProductsDocument} {...props} />
    );
    

/**
 * __useSrpRecommendedProductsQuery__
 *
 * To run a query within a React component, call `useSrpRecommendedProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSrpRecommendedProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSrpRecommendedProductsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSrpRecommendedProductsQuery(baseOptions: Apollo.QueryHookOptions<SrpRecommendedProductsQuery, SrpRecommendedProductsQueryVariables> & ({ variables: SrpRecommendedProductsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SrpRecommendedProductsQuery, SrpRecommendedProductsQueryVariables>(SrpRecommendedProductsDocument, options);
      }
export function useSrpRecommendedProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SrpRecommendedProductsQuery, SrpRecommendedProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SrpRecommendedProductsQuery, SrpRecommendedProductsQueryVariables>(SrpRecommendedProductsDocument, options);
        }
export function useSrpRecommendedProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SrpRecommendedProductsQuery, SrpRecommendedProductsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SrpRecommendedProductsQuery, SrpRecommendedProductsQueryVariables>(SrpRecommendedProductsDocument, options);
        }
export type SrpRecommendedProductsQueryHookResult = ReturnType<typeof useSrpRecommendedProductsQuery>;
export type SrpRecommendedProductsLazyQueryHookResult = ReturnType<typeof useSrpRecommendedProductsLazyQuery>;
export type SrpRecommendedProductsSuspenseQueryHookResult = ReturnType<typeof useSrpRecommendedProductsSuspenseQuery>;
export type SrpRecommendedProductsQueryResult = Apollo.QueryResult<SrpRecommendedProductsQuery, SrpRecommendedProductsQueryVariables>;